import { render, staticRenderFns } from "./RelationshipsAddressesEdit.vue?vue&type=template&id=80b3b634&"
import script from "./RelationshipsAddressesEdit.vue?vue&type=script&lang=js&"
export * from "./RelationshipsAddressesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports